 import { Button, Modal } from "react-bootstrap";
 import { useTranslation } from "react-i18next";
 import spinnerTitle from "components/others/spinnerTitle";
 import SvgSave from "components/svg/SvgSave";
 import { useRef, useState } from "react";
import AddExpendFormik from "./AddExpendFormik";
  
 const AddExpendModal = ({showObject, setShowObject}) => {
 
     const { t } = useTranslation(['Objects']);
     const [ submittingFormik, setSubmittingFormik ] = useState(false);
     const refFormik = useRef();
      
     return (
        <Modal 
            show={showObject!==false} 
            onHide={()=>setShowObject(false)}
            onShow={()=>setSubmittingFormik(false)}
            size="xl"
            backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton className="border-bottom">
                <Modal.Title>{showObject?.income ? t('addExpend.btnAddIncome') : t('addExpend.btnAddExpend')}</Modal.Title> 
            </Modal.Header>
            <Modal.Body >
                <AddExpendFormik
                income={showObject?.income}
                setShowObject={setShowObject}
                setSubmittingFormik={setSubmittingFormik}
                refFormik={refFormik}/>

            </Modal.Body>
            <Modal.Footer>
                <Button className="me-1"
                    variant="secondary"
                    disabled={submittingFormik}
                    onClick={()=>setShowObject(false)}>
                    {t('common:buttons.close')}
                </Button>
                <Button variant="info"
                    type="submit"
                    onClick={()=>{
                        refFormik.current.submitForm();
                    }}>
                    {spinnerTitle((<><SvgSave className="me-2 mtop-2"/>{t('common:buttons.save')}</>), submittingFormik, t('common:buttons.saving'))}
                </Button>
                
            </Modal.Footer>
         </Modal>
     )
 }
 
 export default AddExpendModal;